<template>
	<b-container>
		<transition name="fade">
			<!-- if data not ready -->
			<!-- show loader -->
			<pageLoader key="ap-show-loader-view" v-if="$wait.is('loading apts')"></pageLoader>

			<!-- data is loaded, show table with atps -->
			<b-table-lite
				v-else
				responsive
				:fields="tableFields"
				:items="apts"
				primary-key="id"
				caption-top
				class="apt shadow-sm rounded bg-white"
				table-variant="light"
				thead-class="hidden_header"
			>
				<!-- <template v-slot:table-caption>Accept Protocol Templates:</template> -->

				<!-- <template v-slot:thead-top="data">
					<b-tr>
						<b-th colspan="3" class="py-3 border-0">
							<span class="text-secondary">Accept Protocol available Templates</span>
						</b-th>
					</b-tr>
				</template>-->

				<template v-slot:thead-top="data">
					<tr>
						<th class="border-0"></th>
						<th class="border-0" colspan="4">Accept Protocol available Templates</th>
					</tr>
				</template>

				<!-- slot for id -->
				<template v-slot:cell(id)="row">
					<small>#{{row.item.id}}</small>
				</template>

				<!-- slot for name -->
				<template v-slot:cell(name)="row">
					<p class="mb-0 text-primary">{{ row.item.name }}</p>
					<small>
						<em>{{row.item.description}}</em>
					</small>
				</template>

				<!-- slot for description -->
				<template v-slot:cell(description)="row">
					<em>{{ row.item.description }}</em>
				</template>

				<!-- slot for language -->
				<template v-slot:cell(language.shortName)="row">
					<!-- <small>
						<strong :class="'text-' + row.item.language.color">{{ row.item.language.shortName }}</strong>
					</small>-->
					<b-badge
						pill
						:variant="row.item.language.color"
						class="text-capitalize"
						style="opacity:0.7;font-weight:400;"
					>{{ row.item.language.shortName }}</b-badge>
				</template>

				<!-- slot for show details button -->
				<template v-slot:cell(actions)="row">
					<div>
						<!-- show button -->
						<b-button
							@click.prevent="row.toggleDetails"
							variant="outline-info"
							class="border-0 mr-1"
							title="show template"
						>
							<span v-if="row.detailsShowing">
								<span class="d-none d-sm-none d-md-inline-block">Hide&nbsp;</span>
								<font-awesome-icon :icon="['fas', 'eye-slash']" small fixed-width />
							</span>
							<span v-else>
								<span class="d-none d-sm-none d-md-inline-block">Show&nbsp;</span>
								<font-awesome-icon :icon="['fas', 'eye']" small fixed-width />
							</span>
						</b-button>

						<!-- edit button -->

						<b-button
							@click.prevent="row.toggleDetails"
							variant="outline-warning"
							class="border-0"
							title="edit template"
							:to="{
									name: 'accept-protocol-template-edit-by-id',
									params: { id: row.item.id }
								}"
						>
							<span class="d-none d-sm-none d-md-inline-block">Edit&nbsp;</span>
							<font-awesome-icon :icon="['fas', 'pencil-alt']" small fixed-width />
						</b-button>
					</div>
				</template>

				<!-- hidden on init, clicked show template shows template body (with questions) -->
				<template v-slot:row-details="row" class="apt-body">
					<!-- template body -->
					<APTemplateBody :apTemplate="row.item"></APTemplateBody>
				</template>
			</b-table-lite>
		</transition>
	</b-container>
</template>
<script>
	import { mapState } from "vuex";
	import pageLoader from "@/components/utils/wholePageLoader.vue";
	import APTemplateBody from "@/components/apTemplate/APTemplateBody.vue";

	export default {
		name: "apTemplateList_view",

		components: { APTemplateBody, pageLoader },

		//data
		data() {
			return {
				// tableFIelds
				tableFields: [
					{
						key: "id",
						label: ""
					},
					{
						key: "name",
						label: ""
					},
					{
						key: "language.shortName",
						label: ""
					},
					{
						key: "actions",
						label: "",
						class: "text-right"
					}
				]
			};
		},

		// computed
		computed: {
			...mapState("apTemplate", { apts: "items" })
		},

		// created hook
		created() {},
		// mounted hook
		mounted() {
			this.$wait.start("loading apts");
			// get apt by his id
			this.$store.dispatch("apTemplate/GET_AP_TEMPLATES").then(
				() => {
					this.$wait.end("loading apts");
				},
				error => {
					this.showToast("danger", error.statusText, error.data.message);
					this.$wait.end("loading apts");
				}
			);
		}
	};
</script>
<style>
	.btn {
		box-shadow: none;
	}

	.hidden_header > tr:nth-child(2) {
		display: none;
	}
</style>